module.exports = __webpack_public_path__ + "img/reuse-people.5bafd1d6.svg";